import { useCallback } from "react";
import type { SendEmailFormData } from "@/components/shared/formElements/SendEmailForm";
import { toSendEmailTaskParameters } from "@/features/email/utils/send-email-task-parameters";
import {
  TEACHER_TASK_ACTIONS,
  TEACHER_TASK_ENTITY,
} from "@/features/tasks/constants";
import { useCreateTask } from "@/features/tasks/hooks";

export function useTeacherTaskSubmit() {
  const { createTaskAsync, isPending } = useCreateTask();

  const submitSendEmail = useCallback(
    async (teacherIds: number[], data: SendEmailFormData) => {
      await createTaskAsync({
        entityName: TEACHER_TASK_ENTITY,
        actionName: TEACHER_TASK_ACTIONS.sendEmail,
        selectedIds: teacherIds,
        executionParameters: toSendEmailTaskParameters(data),
        files: data.attachments,
      });
    },
    [createTaskAsync],
  );

  const submitSendNotification = useCallback(
    async (teacherIds: number[], body: string) => {
      await createTaskAsync({
        entityName: TEACHER_TASK_ENTITY,
        actionName: TEACHER_TASK_ACTIONS.sendNotification,
        selectedIds: teacherIds,
        executionParameters: {
          Body: body,
        },
      });
    },
    [createTaskAsync],
  );

  const submitDeactivate = useCallback(
    async (teacherIds: number[]) => {
      await createTaskAsync({
        entityName: TEACHER_TASK_ENTITY,
        actionName: TEACHER_TASK_ACTIONS.bulkDeactivate,
        selectedIds: teacherIds,
      });
    },
    [createTaskAsync],
  );

  return {
    submitSendEmail,
    submitSendNotification,
    submitDeactivate,
    isPending,
  };
}
